import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Trans } from 'react-i18next';
import useAppContext from 'flow/hooks/useAppContext';
import AllowedFileExtensions from './AllowedFileExtensions';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var FileTypeNotAllowed = function FileTypeNotAllowed(_ref) {
  var channel = _ref.channel,
    mimeType = _ref.mimeType,
    fileExtensionUserFriendly = _ref.fileExtensionUserFriendly;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var channeli18Key = getMidPhraseChanneli18Key(channel);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col gap-3",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(Trans, {
        i18n: i18next,
        i18nKey: channeli18Key ? 'tickets.input.unsupported_file_type_in_channel' : 'tickets.input.unsupported_file_type',
        shouldUnescape: true,
        values: _objectSpread({
          fileType: fileExtensionUserFriendly
        }, channeli18Key && {
          channel: i18next.t(channeli18Key)
        }),
        components: [/*#__PURE__*/_jsx("strong", {}, 'ftna-unsupported')]
      })
    }), /*#__PURE__*/_jsx(AllowedFileExtensions, {
      channel: channel,
      mimeType: mimeType
    })]
  });
};
export default FileTypeNotAllowed;
export var getMidPhraseChanneli18Key = function getMidPhraseChanneli18Key(channel) {
  if (channel === 'internal') return 'ticket.note_internal';
  if (channel === 'email') return 'ContactCard.Items.Email';
  if (channel === 'whatsapp') return 'WhatsApp';
  if (channel === 'sms') return 'settings.notifications.device.sms';
  return '';
};